import axios from 'axios'
import Service from '../service'
import SlGroupedOffer from '../../../models/Sale/SlGroupedOffer'

export default class extends Service {
    static model = SlGroupedOffer
    static includes = ['sl_offers.wh_product']

    static remove(data) {
    	return axios.patch(process.env.VUE_APP_API_ROUTE.concat('/massive_delete_offer'), data)
    }
}
